<template>
  <div class="media-manage-content" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" :label="$t('screen.meidia_name')"> </el-table-column>
        <el-table-column prop="file_type" :label="$t('screen.meidia_type')">
          <template slot-scope="scope">
            <span>{{ typeArr[scope.row.file_type] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="file_url" :label="$t('screen.meidia_url')">
          <template slot-scope="scope" >
            <span v-if="scope.row.file_type==0">{{scope.row.text_data}}</span>
            <span v-else-if="scope.row.file_type==1"><img :src="scope.row.file_url" height="80"/></span>
            <video controls v-else width="120">
              <source :src="scope.row.file_url" type="video/mp4">
            </video>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" :label="$t('screen.add_time')"> </el-table-column>
        <el-table-column prop="update_at" :label="$t('screen.update_time')"> </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? $t('screen.add') : $t('screen.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item :label="$t('screen.meidia_name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('screen.meidia_type')" prop="file_type">
            <el-select
              :placeholder="$t('screen.meidia_type')"
              v-model="editOne.file_type"
              style="width: 100%"
              @change="checkType"
            >
              <el-option v-for='(value,index) in typeArr' :label="value" :value="index" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('screen.video_upload')" v-if="editOne.file_type===2">
            <el-upload
              ref="upload"
              name="file"
              class="avatar-uploader"
              :action="Mp4UploadAction()"
              :limit="1"
              :file-list="fileList"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">{{$t('screen.click_upload')}}</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('screen.pic_upload')" v-else-if="editOne.file_type===1">
            <el-upload
              ref="upload"
              name="file"
              class="avatar-uploader"
              :action="Mp4UploadAction()"
              :limit="1"
              :file-list="fileList"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">{{$t('screen.click_upload')}}</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('screen.edit_text')" v-else-if="editOne.file_type===0">
            <div class="form_box">
              <el-input
                type="textarea"
                :placeholder="$t('screen.edit_text_tip')"
                class="textarea_s"
                show-word-limit
                autosize
                v-model="editOne.text_data"
                @input="getText">
              </el-input>
            </div>
            <div class="demo_box">
              <div class="demo_set">
                
              </div>
              <div class="textarea_box">
                <div class="textarea_con" v-html="textarea_data"></div>
              </div>
              
            </div>
            <div class="clear"></div>
          </el-form-item>
          
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import manageApi from "@/api/message/mediaManage"
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      typeArr: this.$t('screen.typeArr'),
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: this.$t('screen.meidia_name_tip'), trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        name: '',
        file_type: '',
        file_url: '',
        text_color: '',
        text_data: '',
        text_font: ''
      },
      textarea_data: '',
      fileList: [],
      file: "",
    };
  },
  methods: {
    Mp4UploadAction() {
      return process.env.VUE_APP_BASE_API+'/public/uploadFile';
    },
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      manageApi.manageList(this.pageInfo).then((res) => {
        // console.log('manageList',res)
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      // console.log(index)
      if (index === "create") {
        this.editOne = {
          name: '',
          file_type: '',
          file_url: '',
          text_color: '',
          text_data: '',
          text_font: ''
        }
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          file_type: index.file_type,
          file_url: index.file_url,
          text_color: index.text_color,
          text_data: index.text_data,
          text_font: index.text_font
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },
    updateItem() {
      manageApi.manageEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      manageApi.manageAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
      .then(() => {
        manageApi.manageDel(id).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success(this.$t('control.del_success'));
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: this.$t('control.cancel_del'),
        });
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.data.code === 1000) {
        this.$message.success(this.$t("control.upload_success"));
        this.editOne.file_url = res.data.data.file_url;
      } else {
        this.$message.error(this.$t("control.error") + res.message);
      }
    },
    beforeAvatarUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if(this.editOne.file_type===1){
        if (testmsg==='jpg'||testmsg==='png') {
          return true;
        }else{
          this.$message({
            message: this.$t("screen.just_pic"),
            type: "error"
          });
          return false
        }
      }else if(this.editOne.file_type===2){
        if (testmsg==='mp4') {
          return true;
        }else{
          this.$message({
            message: this.$t("screen.just_mp4"),
            type: "error",
          });
          return false
        }
      }else{
        return false
      }
    },
    checkType(){
      this.fileList = []
      this.file = ''
    },
    getText(pretext){
      let returnText = pretext.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
      this.textarea_data = returnText
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.media-manage-content {
  width: 100%;
  .el-form-item__content{
	  height:auto !important;
  }
  .textarea_s{
    .el-textarea__inner{
      text-align:center;
      height:480px !important;
    }
  }
  .form_box{
    width:210px;
    float: left;
  }
  .demo_box{
    position: relative;
    width:200px;
    float: right;
    height:480px;
    background: #111;
    .textarea_con{
      width:200px;
      height:480px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #111;
      font-size: 20px;
      box-sizing: border-box;
      padding:10px;
      color:#fff;
      text-align: center;
    }
  }

  .form-info{
    padding-left: 5px;
    .el-form-item__label{
      width:85px;
    }
  }
}
</style>